import {h, Fragment} from "preact"
import { useResponse, AutocompleteElement, Keywords, useCurrencyFormatting, useAppState } from "@nosto/preact"
import { productImagePlaceholder, trendingPages, handleClick } from "../helpers"
import SubmitButton from "./elements/SubmitButton"

export default function Autocomplete() {
    const { products, keywords } = useResponse();
    const { format } = useCurrencyFormatting();
    const { query } = useAppState();

    if (!products?.hits?.length && !keywords?.hits?.length) {
        return
    }

    // function handleClickSubmitButton() {
        
    // }

    return (
        <div
        // ns-background-white
            class="ns-autocomplete ns-absolute ns-d-flex ns-flex-column ns-flex-sm-row ns-align-items-start ns-border-box"
            data-nosto-element="autocomplete"
        >
            <div class="ns-w-100 ns-mt-sm-auto">
                <div class="ns-d-flex ns-flex-column">
                {products?.hits?.length > 0 && (
                    //  ns-flex-grow-1
                        <div class="ns-autocomplete-products ns-d-flex ns-flex-column">
                            <div class="ns-font-regular ns-font-1 ns-uppercase ns-autocomplete-heading">
                                Products
                            </div>
                            <div class="ns-d-flex ns-autocomplete-products-wrapper">
                                {products?.hits?.map(hit => {
                                    return (
                                        <AutocompleteElement hit={hit}>
                                            <div
                                                data-url={hit.url}
                                                class="ns-d-flex ns-flex-column ns-clickable ns-autocomplete-card-container"
                                                data-nosto-element="product"
                                            >
                                                <img
                                                    class="ns-w-100 ns-h-auto ns-object-contain"
                                                    src={hit.imageUrl}
                                                    alt={hit.name}
                                                    // width="60"
                                                    // height="40"
                                                />
                                                <div class="ns-autocomplete-product-name">
                                                    
                                                    {/* ns-clipped ns-text-one-line */}
                                                    <div class="ns-font-4">
                                                        {hit.name}
                                                    </div>
                                                    {/* <div>
                                                        <span>{format(hit.price)}</span>
                                                        {hit.listPrice && hit.listPrice > hit.price && (
                                                            <span class="ns-color-black ns-font-4 ns-text-striked ns-ml-2">
                                                                {format(hit.listPrice)}
                                                            </span>
                                                        )}
                                                    </div> */}
                                                </div>
                                            </div>
                                        </AutocompleteElement>
                                    )
                                })}
                            </div>
                        </div>
                    )}
                    {keywords?.hits?.length > 0 && (
                        <div
                            class={`ns-autocomplete-keywords ns-d-flex ns-flex-column ns-col-12`}
                            // ${
                            //     products?.hits?.length > 0 ? "ns-col-sm-4" : "ns-col-sm-12"
                            // }
                        >
                            <div class="ns-font-regular ns-font-1 ns-uppercase ns-autocomplete-heading">
                                Suggestions
                            </div>
                            <div class="ns-d-flex ns-flex-column">
                                <Keywords
                                    hits={keywords.hits}
                                    keywordComponent={Keyword}
                                    elementComponent={Element}
                                    keywordInCategoryComponent={KeywordInCategory}
                                />
                            </div>
                            {/* {!products?.hits?.length && <SubmitButton text="See all search results" />} */}
                        </div>
                    )}
                    {trendingPages && <div class="ns-autocomplete-pages">
                        <div class="ns-font-regular ns-font-1 ns-uppercase ns-autocomplete-heading" tabIndex="0"
                        role="heading"
                        aria-level="2">
                            Pages
                        </div>
                        <div class="ns-d-flex ns-flex-column">
                            {(window.nostoTrendingPages || trendingPages).map((item, index)=>{
                                return (
                                    <a href={item?.url} class="ns-autocomplete-page ns-d-block ns-font-4">{item?.name}</a>
                                )
                            })}        
                        </div>
                    </div>}
                    <SubmitButton text={`Search for "${query?.query}"`} handleClick={handleClick} />
                </div>
            </div>
        </div>
    )
}

function Keyword({ hit }) {
    return (
        <span data-nosto-element="keyword">
            {hit?._highlight?.keyword ? (
                <span
                    dangerouslySetInnerHTML={{
                        __html: hit._highlight.keyword
                    }}
                ></span>
            ) : (
                hit.keyword
            )}
        </span>
    )
}

function Element({ hit, keywordComponent, filter }) {
    return (
        <AutocompleteElement hit={hit} filter={filter} class="ns-clickable">
            {keywordComponent}
        </AutocompleteElement>
    )
}

function KeywordInCategory({ category, children }) {
    return (
        <span class="ns-clickable">
            {category?.value ? (
                <span>
                    {children}{" "}
                    <span class="ns-keyword-in-category">
                        in <span>{category.value}</span>
                    </span>
                </span>
            ) : (
                children
            )}
        </span>
    )
}
